import $ from 'jquery';

let matrixIndex = 1;
const script = $('#personrow_template').html();

function newRow() {}

function initializeSignupForm() {
  if (script) {
    $('.personer').on('click', '.remove-row', e => {
      // const persons = $(e.currentTarget).parents('.person').parent();
      e.preventDefault();
      $(e.currentTarget)
        .parents('.person')
        .remove();
    });

    $('.add-row').on('click', e => {
      e.preventDefault();
      const newScript = script.replace(/MATRIXINDEX/g, matrixIndex++);
      $('.personer').append(newScript);
    });

    const newScript = script.replace(/MATRIXINDEX/g, matrixIndex++);
    $('.personer').append(newScript);
  }
}

export default initializeSignupForm;

// $('#add_person').on('click', () => {
//     const prefix = `message[${nextIndex++}]`;
//     $('div').addClass('personrow').
//     const newRow = $('
//         <div class="personrow">
//             Navn: <input type="text" name="message[0][name]" />
//             Epost: <input type="text" name="message[0][name]" />
//         </div>
//     ');
//     $('form').append(newRow);
// });

// <form>
//     <div class="personrow">
//         Navn: <input type="text" name="message[0][name]" />
//         Epost: <input type="text" name="message[0][name]" />
//     </div>
// </form>
